import React, { useEffect, useRef } from "react";
import Marquee from "react-fast-marquee";

import "./MarqueeComponent.css";
import partnerOne from "../../Assets/product/1.png";
import partnerTwo from "../../Assets/product/2.png";
import partnerThree from "../../Assets/product/3.png";
import partnerFour from "../../Assets/product/4.png";
import partnerFive from "../../Assets/product/5.png";
import partnerSix from "../../Assets/product/6.png";

const MarqueeComponent = () => {
  const imageList = [
    partnerOne,
    partnerTwo,
    partnerThree,
    partnerFour,
    partnerFive,
    partnerSix,
  ];
  return (
    <>
      <section className="associate-partner-sec sectionDiv m-0">
        <div className="logos">
          <div className="logo_items">
            {imageList.map((val, index) => (
              <img key={index} src={val} alt="Best Diamond Dealer" />
            ))}
          </div>
          <div className="logo_items">
            {imageList.map((val, index) => (
              <img key={index} src={val} alt="Best Diamond Dealer" />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MarqueeComponent;
